import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalController, IonSelect, PopoverController } from '@ionic/angular';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { forkJoin } from 'rxjs';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ClientsService } from 'src/app/business-service/clients/clients.service';
import { ENTITY_NAMES, LEAD_SOURCE_VALUE, ORGANIZATION_TYPES, RECORD_STATUS_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { Router } from '@angular/router';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss'],
})
export class LeadFormComponent implements OnInit {

  @Output() emitLeadId: EventEmitter<any> = new EventEmitter();

  @Input() showOnlyForm: boolean = false;
  @Input() hideVisaService: boolean = false;

  leadForm!: FormGroup;
  leadFormIsDirty: boolean = false;

  disableServiceType: boolean = false;

  editLeadId: any;
  clientId: any;
  leadDetails: any;
  leadId: any;

  leadStatus: any;
  leadSource: any;
  travelServices: any = [];
  leadPriority: any = [];
  assignedUser: any;
  packageIds: any;

  personsFromContact: any = [];

  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _leadService: LeadsService,
    private _lovDataService: LovDataService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _contactService: ContactsService,
    private _validationService: InputValidationsService,
    private _reloadService: ComponentReloadService,
    private _clientService: ClientsService,
    private _modalPopupService: ModalsService,
    private _router: Router,
    private _inventoryService: InventoryService,
    private _itineraryService: ItineraryService,
    private _dmcPackageService: DmcPackageService
  ) { }

  async ngOnInit() {
    let defaultUser = localStorage.getItem('jti');
    let organization = await this._globalService.getLoggedInOrgDetails();
    this.packageIds = organization.organizationDetails.packageId;
    this.leadForm = this._fb.group({
      clientId: [''],
      firstName: [''],
      firstNameWithSalutation: [null, [Validators.required]],
      lastName: ['', [this._validationService.noSpacesValidator()]],
      phoneNumber: [{ countryCode: '+91', phone: '' }, [Validators.required]],
      alternativePhoneNumber: [{ countryCode: '+91', phone: '' }, [this.notSameAsPhoneNumberValidator()]],
      email: ['', [Validators.email]],
      source: ['', Validators.required],
      status: ['New'],
      priority: ['High', Validators.required],
      ownership: [defaultUser, Validators.required],
      ownershipName: [""],
      travelServices: [[], [this._validationService.arrayNotEmptyValidator()]],
      leadNote: [''],
      ownershipRole: [null]
    });

    this.leadForm.valueChanges.subscribe(() => {
      this.leadFormIsDirty = this.leadForm.dirty;
    });

    if (this.editLeadId) {
      forkJoin({
        lead: this._leadService.getLead(this.editLeadId),
        leadStatus: this._lovDataService.getLovData("LeadStatus"),
        leadSource: this._lovDataService.getLovData("LeadSource"),
        travelServices: this._lovDataService.getLovData("TravelServices"),
        leadPriority: this._lovDataService.getLovData("TaskPriority"),
      }).subscribe({
        next: ({ lead, leadStatus, leadSource, travelServices, leadPriority }) => {
          this.leadDetails = lead;
          this.leadStatus = leadStatus;
          this.leadStatus = this._globalService.filterLeadStatusLov(this.leadDetails.status, leadStatus)
          this.leadSource = leadSource;
          this.travelServices = travelServices.map((item: { name: any }) => item.name),
            this.leadPriority = leadPriority,
            this.patchLeadFormData(this.leadDetails);
        },
        error: (error) => {
          console.error("Error loading data", error);
        }
      });
    } else {
      forkJoin({
        leadStatus: this._lovDataService.getLovData("LeadStatus"),
        leadSource: this._lovDataService.getLovData("LeadSource"),
        travelServices: this._lovDataService.getLovData("TravelServices"),
        leadPriority: this._lovDataService.getLovData("TaskPriority"),
      }).subscribe({
        next: ({ leadStatus, leadSource, travelServices, leadPriority }) => {
          this.leadStatus = leadStatus;
          this.leadStatus = this._globalService.filterLeadStatusLov('', leadStatus);
          this.leadSource = leadSource;
          this.travelServices = travelServices.map((item: { name: any }) => item.name);
          this.leadPriority = leadPriority;
          if (this.clientId) {
            this._clientService.getClient(this.clientId).subscribe((data) => {
              this.patchClientInformation(data);
            })
          }
        },
        error: (error) => {
          console.error("Error loading data", error);
        }
      });
    }
  }

  // Custom validations
  notSameAsPhoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneControl = this.leadForm?.get('phoneNumber');
      const alternativePhoneNumberControl = control;
      if (!alternativePhoneNumberControl?.value?.phone) {
        return null;
      }
      if (phoneControl && alternativePhoneNumberControl && (phoneControl.value?.phone === alternativePhoneNumberControl.value?.phone)) {
        return { notSameAsPhoneNumber: true };
      }
      return null;
    }
  }

  get todayDateTime() {
    return this._globalService.getTodaysDateTime();
  }

  patchLeadFormData(formData: any) {
    this.leadForm.patchValue(formData);
    this.leadForm.get('firstNameWithSalutation')?.patchValue({ firstName: formData.firstName, salutation: formData.salutation })

    if (formData.source === LEAD_SOURCE_VALUE.EXISTING_CUSTOMER || formData.source === LEAD_SOURCE_VALUE.COLD_CALL) {
      this.leadForm.get('source')?.disable();
    }

    if (formData.status === RECORD_STATUS_VALUES.QUOTE_CREATED || formData.status === RECORD_STATUS_VALUES.CONVERTED) {
      this.disableServiceType = true;
    }
  }

  // Search person from contacts and patch
  searchExistingPerson(phoneNumber: any) {
    this._clientService.getClientFromPhoneNumber(phoneNumber.phone).subscribe((data) => {
      if (data.status !== false) {
        this.patchClientInformation(data);
      } else {
        this.leadForm.patchValue({
          firstNameWithSalutation: null,
          lastName: "",
          email: "",
          source: ""
        })
        this.leadForm.get('firstNameWithSalutation')?.enable();
        // this.leadForm.get('lastName')?.disable();
        // this.leadForm.get('email')?.disable();
        this.leadForm.get('source')?.enable();
        this.searchPersonInContacts(phoneNumber);
      }
    })
  }

  searchPersonInContacts(phoneNumber: any) {
    this._contactService.getContactFromPhoneNumber(phoneNumber.phone).subscribe((data) => {
      if (data.status != false) {
        if (data.length === 1) {
          this.patchContactInformation(data[0]);
        } else {
          this.personsFromContact = data;
        }
        return true;
      } else {
        return false;
      }
    })
  }

  personFromContactSelected(person: any) {
    this.patchContactInformation(person);
    this.personsFromContact = []
  }

  patchContactInformation(person: any) {
    this.leadForm.patchValue({
      firstNameWithSalutation: { firstName: person.firstName, salutation: person.salutation || null },
      lastName: person.lastName,
      phoneNumber: {
        countryCode: person.phoneCountryCode,
        phone: person.phoneNumber
      },
      email: person.email
    })
    this._responseNotificationService.showMessage("Existing Person In Contacts");
  }

  patchClientInformation(client: any) {
    this.leadForm.patchValue({
      firstNameWithSalutation: { firstName: client.firstName, salutation: client.salutation || null },
      lastName: client.lastName,
      phoneNumber: {
        countryCode: client.phoneNumber.countryCode,
        phone: client.phoneNumber.phone
      },
      email: client.email,
      source: LEAD_SOURCE_VALUE.EXISTING_CUSTOMER
    })

    this.leadForm.get('firstNameWithSalutation')?.enable();
    // this.leadForm.get('lastName')?.disable();
    // this.leadForm.get('email')?.disable();
    this.leadForm.get('source')?.disable();

    this._responseNotificationService.showMessage("Existing Client");
  }

  async closeModal(submitted: boolean = false) {
    if (this.leadFormIsDirty && !submitted) {
      if (await this._globalService.confirmActionPopup("You have unsaved data, confirm to close!", undefined, "Confirm")) {
        this.dismissModal(submitted);
      }
    } else {
      this.dismissModal(submitted);
    }
  }

  dismissModal(submitted: boolean) {
    this._modalController.dismiss({
      'dismissed': true,
      'submitted': submitted
    });
  }

  openSelect(selectElem: IonSelect) {
    selectElem.open();
  }

  assignSelectedUser(event: any) {
    this.leadForm.get("ownershipName")?.setValue(`${event.firstName} ${event.lastName}`);
    this.leadForm.get("ownershipRole")?.setValue(`${event.roleIdentifier}`);
  }

  clearServices() {
    this.leadForm.get("travelServices")?.setValue([]);
  }

  async onSubmit(goNew?: boolean, showItinerary?: boolean, emitLeadId?: boolean): Promise<boolean> {
    if (this.leadForm.valid) {
      try {
        const formData = await this.serializeFormData(this.leadForm.getRawValue());
        // If using recommended itinerary
        const recommendedItinerary = this._globalService.getRecommendedItinerary();
        if(recommendedItinerary){
          if(!this.checkValiditityToUseRecommendedItinerary(formData)) {
            return false;
          }
        }        

        if (this.editLeadId) {
          // Update existing lead
          const data = await this._leadService.updateLead(this.editLeadId, formData).toPromise();
          if (data) {
            this._responseNotificationService.showMessage("Lead Updated Successfully.");
            this.closeModal(true);
            this._reloadService.triggerLeadsReload();
            if (showItinerary) {
              if (data.travelServices.length === 1 && data.travelServices[0] === TRAVEL_SERVICES.VISA) {
                this._modalPopupService.openVisaCreationModal(data.leadId, null);
              } else {
                this._modalPopupService.openItineraryForm(data.clientId, data.leadId, data.itineraryId, null, null);
              }
            }
            return true;
          }
        } else {
          // Create new lead
          const data = await this._leadService.createLead(formData).toPromise();
          if (data) {
            this._responseNotificationService.showMessage("Lead Created Successfully.");
            this.leadForm.reset();
            this.leadId = data.leadId;

            // If using recommended itinerary
            if (recommendedItinerary) {
              await this.useSelectedRecommendedItinerary(recommendedItinerary, data);
              return true;
            }

            if (emitLeadId) {
              this._router.navigate([`leads/details/${this.leadId}`]);
              this.emitLeadId.emit(data);
              return true;
            } else {
              // If the service type is VISA
              if (data.travelServices.length === 1 && data.travelServices[0] === TRAVEL_SERVICES.VISA) {
                this.closeModal(true);
                this._reloadService.triggerLeadsReload();
                if (goNew) {
                  this._modalPopupService.openLeadForm(null, null);
                } else if (showItinerary) {
                  this._router.navigate([`leads/details/${this.leadId}`]);
                  this._modalPopupService.openVisaCreationModal(this.leadId, null);
                } else {
                  this._router.navigate([`leads/details/${this.leadId}`]);
                }
                return true; // Submission successful
              }

              this.closeModal(true);
              if (goNew) {
                this._router.navigate([`leads/list`]);
                this._modalPopupService.openLeadForm(null, null);
              } else if (showItinerary) {
                this._router.navigate([`leads/details/${data.leadId}`]);
                this._modalPopupService.openItineraryForm(data.clientId, data.leadId, null, null, null);
              } else {
                this._router.navigate([`leads/details/${data.leadId}`]);
              }
              this._reloadService.triggerLeadsReload();
              return true; // Submission successful
            }

          }
        }
      } catch (error) {
        console.error("Error during form submission:", error);
        this._responseNotificationService.showMessage("Something went wrong, please try again!", true);
        return false; // Submission failed
      }
    } else {
      // Form is invalid
      this.leadForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
      return false; // Submission failed
    }

    return false; // Default failure in case of unexpected behavior
  }


  private async serializeFormData(formData: any) {
    var serializedData: any = {};
    serializedData.leadNotes = [];
    if (this.leadDetails) {
      serializedData = {
        ...this.leadDetails,
        leadNotes: this.leadDetails.leadNotes || []
      };
    }

    serializedData.firstName = formData.firstNameWithSalutation.firstName;
    serializedData.salutation = formData.firstNameWithSalutation.salutation;
    serializedData.lastName = formData.lastName;
    serializedData.phoneNumber = formData.phoneNumber;
    serializedData.alternativePhoneNumber = formData.alternativePhoneNumber;
    serializedData.email = formData.email;
    serializedData.source = formData.source;
    serializedData.status = formData.status;
    serializedData.travelServices = formData.travelServices;
    serializedData.priority = formData.priority;
    serializedData.ownership = formData.ownership;
    serializedData.ownershipName = formData.ownershipName;
    serializedData.ownershipRole = formData.ownershipRole;
    serializedData.type = ORGANIZATION_TYPES.AGENT;
    if (formData.leadNote) {
      serializedData.leadNotes.push({
        note: formData.leadNote,
        userId: localStorage.getItem("jti"),
        createDate: this._globalService.getTodaysDateTime()
      });
    }
    return serializedData;
  }

  checkValiditityToUseRecommendedItinerary(leadDetails: any): boolean {
    if(leadDetails.travelServices?.includes(TRAVEL_SERVICES.VISA) || !leadDetails.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)){
      this._globalService.customAlert("You cannot use recommended itinerary for Visa or without Sightseeing service.");
      return false;
    }
    return true;
  }

  async useSelectedRecommendedItinerary(itinerary: any, leadDetails: any) {
    if (itinerary.recommendedItineraryType === ENTITY_NAMES.INVENTORY_ITINERARY) {
      try {
        const data = await this._inventoryService.getInventoryItinerary(itinerary.recommendedItineraryId).toPromise();
        const itineraryDetails: any = {
          destination: data.itineraryDetails.destination,
          itineraryName: data.itineraryDetails.itineraryName,
          totalDays: data.itineraryDetails.totalDays,
          note: data.itineraryDetails.note,
          inventoryItineraryId: itinerary.recommendedItineraryId || null,
          packageId: itinerary.recommendedItineraryId || null,
          recommendedOrganizationId: itinerary.recommendedOrganizationId || null,
          leadId: leadDetails.leadId,
          status: RECORD_STATUS_VALUES.DRAFT
        };

        const response = await this._itineraryService.selectRecommendedItinerary(ENTITY_NAMES.INVENTORY_ITINERARY, itineraryDetails).toPromise();
        this._router.navigate([`leads/details/${leadDetails.leadId}`]);
        await this.dismissModal(false);
        await this._modalPopupService.openItineraryForm(leadDetails.clientId, leadDetails.leadId, response.itineraryDetails.itineraryId, null);

      } catch (error) {
        console.error("Error in useSelectedRecommendedItinerary:", error);
      }
    } else if (itinerary.recommendedItineraryType === ENTITY_NAMES.DMC_PACKAGE) {
      const data = await this._dmcPackageService.getPackage(itinerary.recommendedItineraryId, itinerary.recommendedOrganizationId).toPromise();      
      const itineraryDetails: any = {
        destination: data.dmcPackages.destinations,
        itineraryName: data.dmcPackages.packageTitle,
        totalDays: data.dmcPackages.totalDays,
        note: data.dmcPackages.notes,
        inventoryItineraryId: itinerary.recommendedItineraryId || null,
        packageId: itinerary.recommendedItineraryId || null,
        recommendedOrganizationId: itinerary.recommendedOrganizationId || null,
        leadId: leadDetails.leadId,
        status: RECORD_STATUS_VALUES.DRAFT
      };

      const response = await this._itineraryService.selectRecommendedItinerary(ENTITY_NAMES.DMC_PACKAGE, itineraryDetails).toPromise();
      this._router.navigate([`leads/details/${leadDetails.leadId}`]);
      await this.dismissModal(false);
      await this._modalPopupService.openItineraryForm(leadDetails.clientId, leadDetails.leadId, response.itineraryDetails.itineraryId, null);
    }
  }
}
